import React from 'react';
import { container } from 'tsyringe';
import FilteredDataTable from '@base/ui/components/filteredDataTable';
import { accountStatementColumns } from './accountStatementColumns';
import { IUserService } from '../model/interfaces';
import { RangeValue } from '@ui-kit/components/rangePicker';
import Empty from '@ui-kit/components/empty';
import { ReactComponent as NoTransactions } from '@base/assets/images/no_transactions.svg';
import { t } from '@base/utils/helpers';

export default function AccountStatement() {
  const userService: IUserService = container.resolve('userService');
  return (
    <FilteredDataTable
      getData={(range?: RangeValue) => userService.getAccountStatement(range)}
      getTableData={(statement) => statement.rows}
      columns={accountStatementColumns}
      rangePickerTitle={t('account_transactions')}
      footer={(data) => (
        <div>
          <div>
            {t('total_for_period') + ': ' + t('arg_transaction', data.rows.length)}
            <div>{t('arg_tickets_added', data.total_plus)}</div>
            <div>{t('arg_tickets_withdrawn', data.total_minus)}</div>
          </div>
        </div>
      )}
      empty={
        <Empty icon={<NoTransactions height="124px" width="144px" />} style={{ margin: '100px' }}>
          {t('no_transactions')}
        </Empty>
      }
      tableStyle={{ maxHeight: '100%' }}
    />
  );
}
